import * as React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Container, Typography, Box } from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Saletype from './Saletype';
import Fixedprice from '../Fixedprice';
import Fixedpricetab from './Fixedpricetab';
import Notarize from './Notarize';
import { API_URL } from '../../../Config';
import axios from 'axios';
import { useWeb3React } from '@web3-react/core';
import Createnft from './Allnft';


const Profilealltab = () => {
    const [value, setValue] = React.useState('1');
    const { connector, library, chainId, account, activate, deactivate, active, error } = useWeb3React();
    const [saledata  ,setsale] =React.useState([]);
    const [owneeddata ,setowneddata] =React.useState([]);
    const [createdata ,setcreatedata] =React.useState([]);
    const [Notarizedata,setNotarizedata] =React.useState([]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };


        // GET THE ONSALE DATA OF USER
        const getOnSale = async () => {
            await axios
            .get(`${API_URL}/my-items.php?type=onsale&address=${account}`, {
                headers: {
                "Content-Type": "application/json",
                },
            })
            .then((res) => {
                setsale(res.data);
            })
            .catch(console.log);
        };

    // GET THE OWNED DATA OF USER
        const getOnwned = async () => {
    
            await axios
            .get(`${API_URL}/my-items.php?type=owned&address=${account}`, {
                headers: {
                "Content-Type": "application/json",
                },
            })
            .then((res) => {
                setowneddata(res.data);
            })
            .catch(console.log);
        };
        
    // GET THE CREATED DATA OF USER
        const getCreated = async () => {
            await axios
            .get(`${API_URL}/my-items.php?type=created&address=${account}`, {
                headers: {
                "Content-Type": "application/json",
                },
            })
            .then((res) => {
                setcreatedata(res.data);
            })
            .catch(console.log);
        };

        
    // GET THE Notarize DATA OF USER
    const getNotarize= async () => {
        await axios
        .get(`${API_URL}/my-items.php?type=Notarize&address=${account}`, {
            headers: {
            "Content-Type": "application/json",
            },
        })
        .then((res) => {
            setNotarizedata(res.data);
        })
        .catch(console.log);
    };

    React.useEffect(() => {
        if (active) {
        getOnSale();
        getOnwned();
        getCreated();
        getNotarize();
        }
    }, [account]);

    return (
        <div>
            <Box className='tab_one'>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <Container maxWidth='xl'>
                        {/* <Typography variant='h2' fontSize='45px' fontWeight='bold' paddingBottom='20px'>  Explore NFTs </Typography> */}
                        <TabContext value={value}>
                            <Box className='select_btns'>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Create" value="1" />
                                    <Tab label="Onsale" value="2" />
                                    <Tab label="Owned" value="3" />
                                    <Tab label="Notarize" value="4" />
                                </TabList>
                            </Box>
                            <TabPanel value="1" className='sathsmunder'>
                                <Createnft  Createprop={createdata}/>
                            </TabPanel>
                            <TabPanel value="2" className='sathsmunder'>
                                <Saletype Saleprop={saledata} />
                            </TabPanel>
                            <TabPanel value="3" className='sathsmunder'>
                                <Fixedpricetab  Ownedprop={owneeddata}/>
                            </TabPanel>
                            <TabPanel value="4" className='sathsmunder'>
                                <Notarize  Notarizeprop={Notarizedata}/>
                            </TabPanel>
                            
                        </TabContext>
                    </Container>
                </Box>
            </Box>
        </div>
    )
}

export default Profilealltab; 